<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg9"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs13"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath23"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path21" /></clipPath></defs><g
     id="g15"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g17"><g
         id="g19"
         clip-path="url(#clipPath23)"><g
           id="g25"
           transform="translate(143.7739,207.9033)"><path
             d="m 0,0 c 0,-22.136 -17.944,-40.081 -40.081,-40.081 -22.135,0 -40.08,17.945 -40.08,40.081 0,22.136 17.945,40.081 40.08,40.081 C -17.944,40.081 0,22.136 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path27" /></g><g
           id="g29"
           transform="translate(143.7739,191.8711)"><path
             d="M 0,0 H 232.468"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path31" /></g><g
           id="g33"
           transform="translate(109.3618,213.5715)"><path
             d="M 0,0 -11.336,-11.336"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path35" /></g><g
           id="g37"
           transform="translate(456.4028,207.9033)"><path
             d="m 0,0 c 0,-22.136 -17.944,-40.081 -40.081,-40.081 -22.135,0 -40.08,17.945 -40.08,40.081 0,22.136 17.945,40.081 40.08,40.081 C -17.944,40.081 0,22.136 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path39" /></g><g
           id="g41"
           transform="translate(410.6543,213.5715)"><path
             d="M 0,0 11.336,-11.336"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path43" /></g><g
           id="g45"
           transform="translate(63.6128,199.8872)"><path
             d="m 0,0 -38.671,11.049 c -10.324,2.95 -17.442,12.386 -17.442,23.123 v 47.869 c 0,8.085 6.021,14.905 14.044,15.908 l 29.648,3.706 c 13.526,1.691 26.667,5.669 38.859,11.766 l 38.043,19.021 c 15.583,7.792 32.767,11.848 50.189,11.848 h 71.419 c 19.82,0 39.227,-5.652 55.948,-16.292 l 62.576,-39.821 c 0,0 72.665,0 117.998,-21.052 11.226,-5.214 18.276,-16.605 18.276,-28.984 V 11.529 c 0,-12.409 -7.178,-19.545 -16.032,-19.545"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path47" /></g><g
           id="g49"
           transform="translate(159.8062,288.0645)"><path
             d="m 0,0 h -15.462 c -10.63,0 -20.825,4.223 -28.342,11.74 l -12.309,12.308"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path51" /></g><g
           id="g53"
           transform="translate(368.2256,288.0645)"><path
             d="M 0,0 H -176.354"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path55" /></g><g
           id="g57"
           transform="translate(175.8389,223.9355)"><path
             d="M 0,0 H 168.338"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path59" /></g><g
           id="g61"
           transform="translate(7.5,264.0161)"><path
             d="M 0,0 H 16.032"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path63" /></g><g
           id="g65"
           transform="translate(480.4517,247.9839)"><path
             d="M 0,0 H 19.372"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path67" /></g><g
           id="g69"
           transform="translate(223.9355,288.0645)"><path
             d="M 0,0 V 56.113"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path71" /></g><g
           id="g73"
           transform="translate(131.75,291.321)"><path
             d="M 0,0 10.436,46.098"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path75" /></g></g></g></g></svg>
</template>
